<template>
  <div class="swiper-slide course-card-item kb-card-item">
    <div class="course-image">
      <img src="@/assets/img/protocol-black.svg" />
    </div>
    <div class="course_text">
      <p>{{ KBInfo.name }}</p>
      <span>{{ KBInfo.size }}</span>
    </div>
    <div class="course_price"></div>
    <a class="course-button" :href="config.baseUrl + KBInfo.url"> Ссылка на файл<i class="icon-button-arrow"></i> </a>
  </div>
</template>

<script>
import { config } from '@/config'

export default {
  props: {
    KBInfo: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    config() {
      return config
    }
  }
}
</script>
